import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {VoucherQuantityLimitExceededIcon} from 'assets/icons/voucherQuantityLimitExceededIcon';
import Button from 'components/button/Button';
import {useAppDispatch, useAppSelector} from 'hooks';
import {removePromotionVoucherAction, unselectItemIdsAction} from 'store/actions/basket-action';

export type VoucherItemDeselectedAlertContentProps = {
  onClose: () => void;
};

export const VoucherItemDeselectedAlertContent = (props: VoucherItemDeselectedAlertContentProps) => {
  const {onClose} = props;
  const {t} = useTranslation();
  const dispatch = useAppDispatch();
  const {removedItemIds} = useAppSelector((state) => state.alert.details);

  const deselect = () => {
    dispatch(
      removePromotionVoucherAction({
        skipRecalculation: true,
        callback: () => {
          dispatch(unselectItemIdsAction(removedItemIds));
          onClose();
        }
      })
    );
  };

  const keep = () => {
    onClose();
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box alignItems="center" width="100%" display="flex" flexDirection="column" gap={1} mb={2}>
        <VoucherQuantityLimitExceededIcon />
        <Typography fontSize={20} fontWeight={700} align="center">
          {t('alerts.voucherItemDeselected.title')}
        </Typography>
        <Box display="flex" alignItems="center" flexDirection="column">
          <Typography fontSize={16} align="center">
            {t('alerts.voucherItemDeselected.description')}
          </Typography>
        </Box>
      </Box>
      <Button onClick={deselect} shape="rounded" variant="contained">
        {t('alerts.voucherItemDeselected.deselect')}
      </Button>
      <Button onClick={keep} shape="rounded" variant="outlined">
        {t('alerts.voucherItemDeselected.keep')}
      </Button>
    </Box>
  );
};
